import React, { useContext, useEffect, useState } from 'react';
import './SignIn.css';
import axios from 'axios';
import config from '../../config';
import { AuthContext } from '../../contexts/authContext';
import { useNavigate } from 'react-router-dom';
import SySbackground from '../../components/SySbackground/SySbackground';
import CircleProgress from '../../components/CircleProgress/CircleProgress';
import { NotificationManager } from 'react-notifications';

function LoginCallback() {

        const auth = useContext(AuthContext);
        const navigate = useNavigate();
        const [signinLoading, setSigninLoading] = useState(true);

        useEffect(() => {
            async function init(){
            try{
                let params = new URLSearchParams(document.location.search);
                let code = params.get("code");
                let errorDesc = params.get("error_description");
                if(code){
                    //encode uri
                    const encodeGetParams = p => 
                        Object.entries(p).map(kv => kv.map(encodeURIComponent).join("=")).join("&");
                    
                    const params = {
                        grant_type:'authorization_code',
                        redirect_uri:`${config.FE_URL}/login-callback`,
                        code:code,
                        client_id:config.REACT_APP_CLIENT_ID,
                        code_verifier:"9D-aW_iygXrgQcWJd0y0tNVMPSXSChIc2xceDhvYVdGLCBk-JWFTmBNjvKSdOrjTTYazOFbUmrFERrjWx6oKtK2b6z_x4_gHBDlr4K1mRFGyE8yA-05-_v7Dxf3EIYJH"

                    };

                    const axiosParams = {
                        url: '/oauth2/token',
                        method: 'post',
                        baseURL: config.COGNITO_DOMAIN_URL,
                        headers: { 
                            'Content-Type': 'application/x-www-form-urlencoded'
                        },
                        data: encodeGetParams(params)
                    };
        
                    const response = await axios(axiosParams);
                    
                    await auth.signInFromIdpTokensSAML(response.data);
					setSigninLoading(false);
					navigate('/home');

                }else if(errorDesc){
                    NotificationManager.error('An error due to the configuration of your account has occured, please contact the system administrator', 'Account Error', 10000);
                    setTimeout(() => navigate('/login?out=userRequest'), 5000);
                    setSigninLoading(false);
                }else{
					NotificationManager.error('An unexpected error has occured, please contact the system administrator', 'Error', 10000);
                    setTimeout(() => navigate('/login?out=userRequest'), 5000);
                    setSigninLoading(false);
                }
            }catch(e){
                NotificationManager.error('An error due to the configuration of your account has occured, please contact the system administrator', 'Account Error', 10000);
                console.log(e);
                setTimeout(() => navigate('/login?out=userRequest'), 5000);
				setSigninLoading(false);
            }
        }
        init()
    }, [])

  return (
    <div className='signin'>
			{signinLoading && (<CircleProgress isDialog={true}/>)}
			<div className="signin-outer-container">
				<SySbackground/>
				<div id="signin-form" className="signin-container" style={{display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column'}}>
					<span className='login-name-app-2' style={{marginBottom: signinLoading ? '100px' : '0px', fontSize: '24px'}}>{signinLoading ? 'We are logging you in' : 'An error occured with the login'}</span>
                    {!signinLoading&&(<span className='login-name-app-2' style={{marginBottom: '100px', fontSize: '24px'}}>you will be redirected</span>)}
                </div>
			</div>
		</div>
  )
}

export default LoginCallback